module.exports = __webpack_public_path__ + "static/withaspectandperspective-7492464a64b5fe55179887f52cad8af6.png";